function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.27 7.2a8.1 8.1 0 0 0 4.89 1.64V5.19c-1.3 0-2.54-.53-3.46-1.5A5.22 5.22 0 0 1 12.27.1H8.78v11.67c0 .45-.11.9-.34 1.3-.22.39-.54.71-.92.93a2.36 2.36 0 0 1-2.48-.08 2.51 2.51 0 0 1-.87-1 2.65 2.65 0 0 1 .15-2.58c.24-.38.58-.69.98-.88v-3.8c-1.12.21-2.15.75-2.98 1.55a6.47 6.47 0 0 0-1.64 6.43 6.22 6.22 0 0 0 1.85 2.88 5.7 5.7 0 0 0 6.32.86 6.02 6.02 0 0 0 2.5-2.29c.6-1 .92-2.15.92-3.32V7.2Z"
}));